import { CheckoutRules } from '../../interfaces'
import { readString, ScalarActionArgs } from '../../utils/actionArgs'
import { AlertMessageType } from '../../utils/getAlertErrorMessage'
import useCheckoutRuleSelection from './useCheckoutRuleSelection'

interface SetDeliveryDateArgs extends ScalarActionArgs {
  date?: unknown
}

/**
 * The EventManager actions the delivery-date screen dispatches.
 *
 * The payment screen's mirror, one rule type over. The write path is
 * `useCheckoutRuleSelection`, shared between them.
 */
export const useDeliveryDateActions = () => {
  const { select, confirm, back } = useCheckoutRuleSelection(
    CheckoutRules.DELIVERY_DATES,
    AlertMessageType.SetDeliveryDate,
  )

  /**
   * Day tap.
   *
   * The calendar calls back with the day token alone, so a storefront authors
   * `args: { date: '{{this.value}}' }`.
   *
   * ⚠️ **R-8: the token reaching here is the storefront's own string and must
   * stay one.** `readString` returns it unchanged, and
   * `useCheckoutRuleSelection` carries it through to the mutation without
   * rebuilding it. Parsing it into a `Date` anywhere on this path — to
   * validate it, to reformat it — makes the write fail the server's strict
   * equality check for the very day the shopper tapped.
   */
  const setDeliveryDate = (args: SetDeliveryDateArgs = {}) =>
    select(readString(args.date, args.value))

  return {
    setDeliveryDate,
    confirmDeliveryDate: confirm,
    backFromDeliveryDate: back,
  }
}

export default useDeliveryDateActions
